import { render, staticRenderFns } from "./LinkLogo.vue?vue&type=template&id=186345d0"
import script from "./LinkLogo.vue?vue&type=script&lang=js"
export * from "./LinkLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports